import { Box, type BoxProps, type SxProps, type Theme } from "@mui/material";

/** Default max-width page shell used by most in-app pages. */
export function PageContainer({ children, sx, ...rest }: BoxProps) {
  const baseSx: SxProps<Theme> = { p: { xs: 2, sm: 3 }, maxWidth: 1200, mx: "auto" };
  return (
    <Box sx={sx ? ([baseSx, sx] as SxProps<Theme>) : baseSx} {...rest}>
      {children}
    </Box>
  );
}
